/**
 * One live rows ref per host writer (`onDocVariablesChange` /
 * `onCampaignVariablesChange`). The in-doc variables table and every
 * linked-variable-row each mount their own VariablesTable; without this they
 * patch from stale snapshots and wipe each other's values.
 */

const sharedRefs = new WeakMap();

export const getSharedRowsRef = (owner, fallbackRows = []) => {
  if (!owner) return null;
  let ref = sharedRefs.get(owner);
  if (!ref) {
    ref = { current: Array.isArray(fallbackRows) ? fallbackRows : [] };
    sharedRefs.set(owner, ref);
  }
  return ref;
};

/** Keep live rows for ids that still exist; take brand-new ids from incoming. */
export const mergeLiveRows = (live, incoming) => {
  const next = Array.isArray(incoming) ? incoming : [];
  const prev = Array.isArray(live) ? live : [];
  if (!prev.length) return next;
  const liveById = new Map(prev.map((row) => [row.id, row]));
  return next.map((row) => (row?.id != null && liveById.has(row.id) ? liveById.get(row.id) : row));
};
